import axiosInstance from "auth/FetchInterceptor";
import {
    GET_ALL_SETTING_SURCHARGE_CATEGORY,
    SETTING_SURCHARGE_CATEGORY_UPDATE,
} from "constants/ApiConstant";

const SettingSurchargeCategoryService = {};

SettingSurchargeCategoryService.getAll = function () {
    return axiosInstance.get(GET_ALL_SETTING_SURCHARGE_CATEGORY, null);
};

SettingSurchargeCategoryService.update = function (data) {
    return axiosInstance.put(SETTING_SURCHARGE_CATEGORY_UPDATE, data);
};

export default SettingSurchargeCategoryService;